import {FAILURE, PENDING, SUCCESS} from '../../constants'
import {getGroups as getGroupsAPI} from '../../../services/groups'
import fixture from '../../../fixtures/reservations/get-configuration.json'

export async function getGroups(dispatch) {
  try {
    dispatch({type: PENDING})
    let response = await getGroupsAPI()
    dispatch({type: SUCCESS, payload: response})
    return response
  } catch (e) {
    console.log(`Get Groups Failed`)
    dispatch({type: FAILURE, payload: e})
    return Promise.reject(e)
  }
}
